// extracted by mini-css-extract-plugin
export default {"tagsContainer":"Tags_tagsContainer--EHI","tagsContainerItem":"Tags_tagsContainerItem--TTZ","tagTitle":"Tags_tagTitle--gaH"};